import { render, staticRenderFns } from "./ladder.vue?vue&type=template&id=dae90736"
import script from "./ladder.vue?vue&type=script&lang=js"
export * from "./ladder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dae90736')) {
      api.createRecord('dae90736', component.options)
    } else {
      api.reload('dae90736', component.options)
    }
    module.hot.accept("./ladder.vue?vue&type=template&id=dae90736", function () {
      api.rerender('dae90736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/ladder.vue"
export default component.exports